module.exports = __webpack_public_path__ + "static/img/アセット 49@3x.1e04481.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 49@3x.png
// module id = WHpD
// module chunks = 1